import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";

import {
  GridRow,
  GridColumn,
  Carousel,
  Button,
  LazyImg,
  Modal,
  Img,
  Utils,
  Toastr,
} from "arv-reactcomponents";
import LazyLoad from 'react-lazyload';

import Methods from "./methods.js";

import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";
import { Endpoints } from "npmlinks-constants";

import CarouselModal from "./CarouselModal";

@inject("ProductStore", "CommonStore")
@observer
class MainCarousel extends Component {
  static isActive(index, selectedIndex) {
    return (index === selectedIndex && "is-active") || "";
  }

  constructor(props) {
    super(props);
    const [listFirstItem] = props.list || [];

    this.state = {
      isZoomPopupActive: false,
      isZoomPreviewActive: false,
      list: [listFirstItem],
    };

    this.isZoomOpened = false;
    this.onSwipe = this.onSwipe.bind(this);
    this.scroll = this.scroll.bind(this);
    this.renderItems = this.renderItems.bind(this);
    this.zoomPopupShow = this.zoomPopupShow.bind(this);
    this.zoomPopupHide = this.zoomPopupHide.bind(this);

    this.zoomMove = this.zoomMove.bind(this);
    this.zoomLeave = this.zoomLeave.bind(this);
    this.handleKeyDown =  this.handleKeyDown.bind(this);
    this.productImageModalRef = React.createRef();
  }

  onSwipe(direction) {
    if (!direction.vertical) {
      this.scroll(direction.horizontal);
    }
  }

  get imageAlt() {
    const { pdpDetails } = this.props.ProductStore;
    const { brandName, name } = pdpDetails;

    return `${brandName} ${name}` || Methods.imageAlt();
  }

  get isZoomPreviewActive() {
    const { isZoomPreviewActive } = this.state;

    return (isZoomPreviewActive && " is-active") || "";
  }

  get pdpMainImage() {
    const { mainImage } = this.props;
    const {
      pdpDetails: { images = [{ medium: null }] },
    } = this.props.ProductStore;
    const [{ medium: mediumImage }] = images;

    return mainImage || mediumImage;
  }

  get showPlaceholder() {
    const { ProductLoader, mainImage } = this.props;

    return ProductLoader || (mainImage && true) || false;
  }

  get hidePlaceholderClassName() {
    const { ProductLoader, mainImage } = this.props;

    return (!(ProductLoader || mainImage) && "nwc-hide") || "";
  }

  get isImgPlaceholder() {
    return (this.pdpMainImage && "is-imgplaceholder") || "";
  }

  get hideCarouselClassName() {
    const { ProductLoader, mainImage } = this.props;

    return ((ProductLoader || mainImage) && "nwc-hide") || "";
  }

  get previewImage() {
    const { list, index } = this.props;

    const selectedIndexObj = list[index];

    return selectedIndexObj && selectedIndexObj.zoom;
  }

  get zoomImage() {
    const { list, index } = this.props;
    const { isDesktop } = this.props.CommonStore;

    const selectedIndexObj = list[index];

    return (
      (isDesktop && selectedIndexObj && selectedIndexObj.zoom) ||
      this.previewImage
    );
  }

  scroll(type) {
    const { index } = this.props;
    const newIndex = type === "next" ? index + 1 : index - 1;
    if (newIndex > -1 && newIndex < this.props.list.length) {
      this.props.setImageIndex(newIndex);
    }
    const gaLabel = type === "next" ? "right" : "left";
    Analytics.trackEvent({
      action: Event.action.IMAGE_CHANGE,
      category: Event.category.PRODUCT_DESCRIPTION_PAGE,
      label: gaLabel,
    });
  }

  zoomPopupShow() {
    const { isDesktop } = this.props.CommonStore;
    const { list, index } = this.props;
    const hasVideo = list && index && list[index].video ? true : false;
    if (!isDesktop && !this.isZoomOpened) {
      Toastr.showToastr({
        className:
          "nwc-toastr-list-notification nw-toastr nw-maincarousel-previewtoastr",
        message: "Tap on the image to zoom",
        timeout: 3000,
      });

      this.isZoomOpened = true;
    }

    this.setState({
      isZoomPopupActive: true,
    });
    Analytics.trackEvent({
      action: hasVideo ? Event.action.VIDEO_CLICK : Event.action.ZOOM_CLICK,
      category: Event.category.PRODUCT_DESCRIPTION_PAGE,
    });
  }

  zoomPopupHide() {
    this.setState({
      isZoomPopupActive: false,
    });
  }

  zoomMove(e) {
    const { isDesktop } = this.props.CommonStore;
    if (!isDesktop || !this.zoomImage) {
      return;
    }
    const { isZoomPreviewActive } = this.state;
    if (!isZoomPreviewActive) {
      this.setState({
        isZoomPreviewActive: true,
      });
    }
    const { pageX, pageY } = e;

    Utils.requestAnimationFrame(() => {
      const elem = document.querySelector("#pdp-carousel");
      const zoomElem = document.querySelector("#pdp-zoompreview");
      const zoomElemImg = document.querySelector("#pdp-zoompreviewimage");

      Methods.movePreview(pageY, pageX, elem, zoomElem, zoomElemImg);
    });
  }

  zoomLeave() {
    this.setState({
      isZoomPreviewActive: false,
    });
  }

  handleKeyDown(e) {
    e.keyCode === 37 ?  this.scroll("prev"): e.keyCode === 39 ?  this.scroll("next") : null;
  }


  renderItems(item, index, parent) {
    const { isDesktop } = this.props.CommonStore;
    const activeClass = index === this.props.index ? "is-active" : "";

    const { large: largeImage, medium: mediumImage, video: videoSrc } = item;
    const carouselImg = largeImage;
    // (isDesktop && largeImage) || mediumImage;
    const videoClass = videoSrc ? "nw-carousel-video" : "";

    return (
      <div
        role="presentation"
        className={`nw-maincarousel-image ${index} ${activeClass} ${videoClass}`}
        key={index}
      >
        <Fragment>
        <LazyLoad>
          <LazyImg
            onWinLoad={index === 0}
            className="nw-maincarousel-lazy"
            index={this.props.index}
            src={carouselImg}
            rootMargin={`1500px`}
            parentElement={parent}
            alt={this.imageAlt}
          />
          </LazyLoad>
          {(videoSrc && (
            <i className="icomoon-play2 nw-maincarousel-videoicon" />
          )) ||
            null}
        </Fragment>
      </div>
    );
  }

  componentDidMount() {
    const { list } = this.props;
    this.setState({
      list,
    });
  }

  componentDidUpdate(){
    if(this.productImageModalRef.current){
      this.productImageModalRef.current.focus();
    }
  }

  render() {
    const { list, index, reviews = false } = this.props;
    const { isDesktop } = this.props.CommonStore;
    const { isZoomPopupActive } = this.state;
    return (
      <Fragment>
        <GridRow className="nw-maincarousel-row">
          {(isDesktop || this.showPlaceholder) && (
            <GridColumn
              className={`nw-maincarousel-col ${this.hidePlaceholderClassName}`}
            >
              <div
                className={`nw-maincarousel-placeholder ${
                  this.isImgPlaceholder
                }`}
              >
                {this.pdpMainImage ? (
                  <Img
                    className="nw-maincarousel-image"
                    src={this.pdpMainImage}
                    alt={this.imageAlt}
                  />
                ) : null}
              </div>
            </GridColumn>
          )}
          {!this.showPlaceholder && (
            <GridColumn
              className={`nw-maincarousel-col ${this.hideCarouselClassName}`}
            >
              <Button
                disabled={index === 0}
                className={`nwc-btn-primary-txt nw-maincarouselbutton nw-maincarouselbutton-prev ${
                  this.hideButtons
                }`}
                onClick={() => this.scroll("prev")}
              >
                <i className="icomoon-arrow_left nw-maincarouselbutton-icon" />
              </Button>
              <div className="nw-maincarousel-wrapper">
                <Carousel
                  id="pdp-carousel"
                  className="nw-maincarousel"
                  index={index}
                  items={list}
                  renderItems={this.renderItems}
                  onClick={!reviews ? this.zoomPopupShow : undefined}
                  onSwipe={this.onSwipe}
                  onMouseMove={!reviews ? this.zoomMove : undefined}
                  onMouseLeave={!reviews ? this.zoomLeave : undefined}
                />
              </div>
              <Button
                disabled={index === list.length - 1}
                className={`nwc-btn-primary-txt nw-maincarouselbutton nw-maincarouselbutton-next ${
                  this.hideButtons
                }`}
                onClick={() => this.scroll("next")}
              >
                <i className="icomoon-arrow_right nw-maincarouselbutton-icon" />
              </Button>
              <div
                id="pdp-zoompreview"
                className={`nw-maincarousel-zoompreview${
                  this.isZoomPreviewActive
                }`}
              >
                <Img id="pdp-zoompreviewimage" src={this.zoomImage} />
              </div>
              <div className="nw-mobile-only nw-maincarousel-dotswrapper">
                {list.length > 1
                  ? list.map((item, dotIndex) => (
                      <div
                        key={`${item.large}${item.video}`}
                        className={`nw-maincarousel-dots ${MainCarousel.isActive(
                          dotIndex,
                          index,
                        )}`}
                      />
                    ))
                  : ""}
              </div>
            </GridColumn>
          )}
        </GridRow>
        <Modal
          isOpen={isZoomPopupActive}
          onClose={this.zoomPopupHide}
          className="nw-maincarouselzoom-modal"
        >
          <div onKeyDown={this.handleKeyDown}
          tabIndex="-1"
          ref={this.productImageModalRef}
          className="nw-image-container-outline"
          >
          <CarouselModal.component
            index={index}
            list={list}
            onSwipe={this.onSwipe}
            scroll={this.scroll}
            previewImage={this.previewImage}
            zoomImage={this.zoomImage}
          />
          </div>
        </Modal>
      </Fragment>
    );
  }
}
MainCarousel.wrappedComponent.defaultProps = {
  ProductLoader: false,
  reviews: false,
  list: [
    {
      large: Endpoints.noImg,
      zoom: Endpoints.noImg,
    },
  ],
  mainImage: null,
};
MainCarousel.wrappedComponent.propTypes = {
  ProductLoader: PropTypes.bool,
  reviews: PropTypes.bool,
  index: PropTypes.number.isRequired,
  setImageIndex: PropTypes.func.isRequired,
  mainImage: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      large: PropTypes.string,
      zoom: PropTypes.string,
    }),
  ),
  ProductStore: PropTypes.shape({
    pdpDetails: PropTypes.shape({
      images: PropTypes.arrayOf(PropTypes.shape({})),
    }).isRequired,
  }).isRequired,
};

export { default as CarouselModal } from "./CarouselModal";
export { default as CarouselPreview } from "./CarouselPreview";

const getFinalComponent = component =>
  inject("CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: MainCarousel.wrappedComponent,
  component: MainCarousel,
};

export default ProjectComponent;
